import React from 'react';

const RoutesUI = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 via-yellow-50 to-amber-50 py-8 px-4">
      {/* Top Routes Button */}
      <div className="flex justify-center mb-8 md:mb-12">
        <button className="bg-yellow-400 hover:bg-yellow-500 text-white font-bold text-base md:text-xl px-8 md:px-16 py-2 md:py-3 rounded-full shadow-lg"style={{ color: 'rgba(65, 1, 150, 1)' }}>
          Top Routes
        </button>
      </div>

      {/* Main Heading */}
      <div className="text-center mb-12 md:mb-16">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold tracking-wide">
          <span className="text-sky-400"style={{ color: 'rgba(65, 1, 150, 1)' }}>Major Routes</span>{' '}
          <span className="text-gray-900">We Serve</span>
        </h1>
      </div>

      {/* Desktop View */}
      <div className="hidden lg:block relative max-w-[1400px] mx-auto h-[600px]">
        
        {/* THENI - Left Side */}
        <div className="absolute left-0 top-1/2 -translate-y-1/2">
          <div className="text-center">
            <h2 className="text-4xl font-bold text-sky-400 mb-6 tracking-wider"style={{ color: 'rgba(65, 1, 150, 1)' }}>HYDERABAD</h2>
            <div 
              className="relative bg-gradient-to-b from-sky-400 to-sky-500 overflow-hidden shadow-2xl"
              style={{
                width: '300px',
                height: '300px',
                clipPath: 'polygon(50% 0%, 100% 0%, 100% 70%, 50% 100%, 0% 70%, 0% 0%)',
                borderRadius: '50% 50% 50% 50% / 60% 60% 40% 40%'
              }}
            >
              <img 
                src="https://media.istockphoto.com/id/2168524178/photo/group-of-people-in-front-of-building.jpg?s=612x612&w=0&k=20&c=zhIMeFy0MdJHZ17bhv3LqvcdRsJ1w_uIQ3i1Nv5s82c="
                alt="Theni"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        
        <div className="absolute right-0 top-1/2 -translate-y-1/2">
          <div className="text-center">
            <h2 className="text-4xl font-bold text-sky-400 mb-6 tracking-wider"style={{ color: 'rgba(65, 1, 150, 1)' }}>CHENNAI</h2>
            <div 
              className="relative bg-gradient-to-b from-sky-400 to-sky-500 overflow-hidden shadow-2xl"
              style={{
                width: '300px',
                height: '300px',
                clipPath: 'polygon(50% 0%, 100% 0%, 100% 70%, 50% 100%, 0% 70%, 0% 0%)',
                borderRadius: '50% 50% 50% 50% / 60% 60% 40% 40%'
              }}
            >
              <img 
                src="https://www.shutterstock.com/image-photo/chennai-india-circa-march-2019-600nw-2416291361.jpg"
                alt="Chennai"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        
        <svg className="absolute inset-0 w-full h-full" style={{ zIndex: 0 }}>
          <line x1="350" y1="200" x2="1050" y2="200" 
                stroke="#93c5fd" strokeWidth="2" strokeDasharray="8,8" />
          <line x1="420" y1="200" x2="420" y2="400" 
                stroke="#93c5fd" strokeWidth="2" strokeDasharray="8,8" />
          <line x1="610" y1="200" x2="610" y2="400" 
                stroke="#93c5fd" strokeWidth="2" strokeDasharray="8,8" />
          <line x1="790" y1="200" x2="790" y2="400" 
                stroke="#93c5fd" strokeWidth="2" strokeDasharray="8,8" />
          <line x1="980" y1="200" x2="980" y2="400" 
                stroke="#93c5fd" strokeWidth="2" strokeDasharray="8,8" />
        </svg>

        {/* Middle Routes */}
        <div className="absolute inset-0" style={{ zIndex: 1 }}>
          
          {/* Top Row */}
          <div className="absolute" style={{ left: '420px', top: '100px', transform: 'translateX(-50%)' }}>
            <div className="text-center">
              <p className="text-gray-900 font-semibold text-base mb-3">Bangalore</p>
              <div className="w-32 h-32 rounded-full overflow-hidden shadow-xl border-4 border-white bg-white">
                <img src="https://s7ap1.scene7.com/is/image/incredibleindia/vidhana-soudha-bangalore-karnataka-hero?qlt=82&ts=1742199603184" alt="Bodinayakkanur" className="w-full h-full object-cover" />
              </div>
            </div>
          </div>

          <div className="absolute" style={{ left: '610px', top: '100px', transform: 'translateX(-50%)' }}>
            <div className="text-center">
              <p className="text-gray-900 font-semibold text-base mb-3">Vizag</p>
              <div className="w-32 h-32 rounded-full overflow-hidden shadow-xl border-4 border-white bg-white">
                <img src="https://i.pinimg.com/736x/7c/31/c1/7c31c15c4a1fbb0ae70deef86ab03514.jpg" alt="Yadagirigutta" className="w-full h-full object-cover" />
              </div>
            </div>
          </div>

          <div className="absolute" style={{ left: '790px', top: '100px', transform: 'translateX(-50%)' }}>
            <div className="text-center">
              <p className="text-gray-900 font-semibold text-base mb-3">Goa</p>
              <div className="w-32 h-32 rounded-full overflow-hidden shadow-xl border-4 border-white bg-white">
                <img src="https://t3.ftcdn.net/jpg/00/77/00/26/360_F_77002615_Gl1Hk6qZpi2xCAlX8EUTRLBqC4ei6QfC.jpg" alt="Tindivanam" className="w-full h-full object-cover" />
              </div>
            </div>
          </div>

          {/* Small connector circles */}
          <div className="absolute" style={{ left: '515px', top: '280px', transform: 'translateX(-50%)' }}>
            <div className="w-24 h-24 rounded-full overflow-hidden shadow-lg border-4 border-white bg-white">
              <img src="https://images.nativeplanet.com/img/2015/01/08-1420714688-bidar1.jpg" alt="Route" className="w-full h-full object-cover" />
            </div>
          </div>

          <div className="absolute" style={{ left: '700px', top: '280px', transform: 'translateX(-50%)' }}>
            <div className="w-24 h-24 rounded-full overflow-hidden shadow-lg border-4 border-white bg-white">
              <img src="https://dynamic.tourtravelworld.com/blog_images/must-visit-tourist-places-near-hyderabad-within-500-km-20240817052556.jpg" alt="Route" className="w-full h-full object-cover" />
            </div>
          </div>

          <div className="absolute" style={{ left: '885px', top: '280px', transform: 'translateX(-50%)' }}>
            <div className="w-24 h-24 rounded-full overflow-hidden shadow-lg border-4 border-white bg-white">
              <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRJ2zC65B5oNQmvc9ki4X2H3gIeYEFBoI9G2g&s" alt="Route" className="w-full h-full object-cover" />
            </div>
          </div>

          {/* Bottom Row */}
          <div className="absolute" style={{ left: '420px', top: '430px', transform: 'translateX(-50%)' }}>
            <div className="text-center">
              <div className="w-32 h-32 rounded-full overflow-hidden shadow-xl border-4 border-white bg-white mb-3">
                <img src="https://www.balajitravels.org/storage/destinations/160724035049-mallikarjuna-temple-jyotirlingas-andhra-pradesh.webp" alt="Tirupati" className="w-full h-full object-cover" />
              </div>
              <p className="text-gray-900 font-semibold text-base">Srisailam</p>
            </div>
          </div>

          <div className="absolute" style={{ left: '610px', top: '430px', transform: 'translateX(-50%)' }}>
            <div className="text-center">
              <div className="w-32 h-32 rounded-full overflow-hidden shadow-xl border-4 border-white bg-white mb-3">
                <img src="https://upload.wikimedia.org/wikipedia/commons/a/a4/Mysore_Palace_Morning.jpg" alt="AnanthagiriHills" className="w-full h-full object-cover" />
              </div>
              <p className="text-gray-900 font-semibold text-base">Mysore</p>
            </div>
          </div>

          <div className="absolute" style={{ left: '790px', top: '430px', transform: 'translateX(-50%)' }}>
            <div className="text-center">
              <div className="w-32 h-32 rounded-full overflow-hidden shadow-xl border-4 border-white bg-white mb-3">
                <img src="https://media.istockphoto.com/id/1175506409/photo/small-village-amidst-terrace-farms-on-hills-of-kodaikanal-tamil-nadu.jpg?s=612x612&w=0&k=20&c=E_SZ5ejTB3kuHej2RMX6HAWq26V3n0Jyfx4nSxs5rUY=" alt="RamojiFilmCity" className="w-full h-full object-cover" />
              </div>
              <p className="text-gray-900 font-semibold text-base">ooty & Kodaikanal</p>
            </div>
          </div>

          <div className="absolute" style={{ left: '980px', top: '430px', transform: 'translateX(-50%)' }}>
            <div className="text-center">
              <div className="w-32 h-32 rounded-full overflow-hidden shadow-xl border-4 border-white bg-white mb-3">
                <img src="https://odishatourism.gov.in/content/dam/resized-web-page-banner-images-/category-/glimpses-of-odisha.jpg" alt="NagarjunaSagar" className="w-full h-full object-cover" />
              </div>
              <p className="text-gray-900 font-semibold text-base">odisha</p>
            </div>
          </div>

        </div>
      </div>

      {/* Mobile/Tablet View */}
      <div className="lg:hidden max-w-4xl mx-auto">
        {/* THENI */}
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-sky-400 mb-4 tracking-wider"style={{ color: 'rgba(65, 1, 150, 1)' }}>HYDERABAD</h2>
          <div className="flex justify-center">
            <div 
              className="relative bg-gradient-to-b from-sky-400 to-sky-500 overflow-hidden shadow-2xl"
              style={{
                width: '200px',
                height: '200px',
                clipPath: 'polygon(50% 0%, 100% 0%, 100% 70%, 50% 100%, 0% 70%, 0% 0%)',
                borderRadius: '50% 50% 50% 50% / 60% 60% 40% 40%'
              }}
            >
              <img 
                src="https://media.istockphoto.com/id/2168524178/photo/group-of-people-in-front-of-building.jpg?s=612x612&w=0&k=20&c=zhIMeFy0MdJHZ17bhv3LqvcdRsJ1w_uIQ3i1Nv5s82c="
                alt="Theni"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        {/* Route Cities Grid */}
        <div className="grid grid-cols-2 gap-8 mb-12">
          {/* Bodinayakkanur */}
          <div className="text-center">
            <p className="text-gray-900 font-semibold text-sm mb-2">Bangalore</p>
            <div className="w-24 h-24 mx-auto rounded-full overflow-hidden shadow-xl border-4 border-white bg-white">
              <img src="https://s7ap1.scene7.com/is/image/incredibleindia/vidhana-soudha-bangalore-karnataka-hero?qlt=82&ts=1742199603184" alt="Bodinayakkanur" className="w-full h-full object-cover" />
            </div>
          </div>

          {/* Cumbam */}
          <div className="text-center">
            <p className="text-gray-900 font-semibold text-sm mb-2">Vizag</p>
            <div className="w-24 h-24 mx-auto rounded-full overflow-hidden shadow-xl border-4 border-white bg-white">
              <img src="https://i.pinimg.com/736x/7c/31/c1/7c31c15c4a1fbb0ae70deef86ab03514.jpg" alt="Yadagirigutta" className="w-full h-full object-cover" />
            </div>
          </div>

          {/* Dindigul */}
          <div className="text-center">
            <p className="text-gray-900 font-semibold text-sm mb-2">Goa</p>
            <div className="w-24 h-24 mx-auto rounded-full overflow-hidden shadow-xl border-4 border-white bg-white">
              <img src="https://t3.ftcdn.net/jpg/00/77/00/26/360_F_77002615_Gl1Hk6qZpi2xCAlX8EUTRLBqC4ei6QfC.jpg" alt="GolcondaFort&Charminar" className="w-full h-full object-cover" />
            </div>
          </div>

          {/* Trichy */}
          <div className="text-center">
            <p className="text-gray-900 font-semibold text-sm mb-2">Srisailam</p>
            <div className="w-24 h-24 mx-auto rounded-full overflow-hidden shadow-xl border-4 border-white bg-white">
              <img src="https://www.balajitravels.org/storage/destinations/160724035049-mallikarjuna-temple-jyotirlingas-andhra-pradesh.webp" alt="AnanthagiriHills" className="w-full h-full object-cover" />
            </div>
          </div>

          {/* Perambalur */}
          <div className="text-center">
            <p className="text-gray-900 font-semibold text-sm mb-2">Mysore</p>
            <div className="w-24 h-24 mx-auto rounded-full overflow-hidden shadow-xl border-4 border-white bg-white">
              <img src="https://upload.wikimedia.org/wikipedia/commons/a/a4/Mysore_Palace_Morning.jpg" alt="Perambalur" className="w-full h-full object-cover" />
            </div>
          </div>

          {/* Tindivanam */}
          <div className="text-center">
            <p className="text-gray-900 font-semibold text-sm mb-2">ooty & Kodaikanal</p>
            <div className="w-24 h-24 mx-auto rounded-full overflow-hidden shadow-xl border-4 border-white bg-white">
              <img src="https://media.istockphoto.com/id/1175506409/photo/small-village-amidst-terrace-farms-on-hills-of-kodaikanal-tamil-nadu.jpg?s=612x612&w=0&k=20&c=E_SZ5ejTB3kuHej2RMX6HAWq26V3n0Jyfx4nSxs5rUY=" alt="Tindivanam" className="w-full h-full object-cover" />
            </div>
          </div>

          {/* Chengalpattu */}
          <div className="text-center">
            <p className="text-gray-900 font-semibold text-sm mb-2">odisha</p>
            <div className="w-24 h-24 mx-auto rounded-full overflow-hidden shadow-xl border-4 border-white bg-white">
              <img src="https://odishatourism.gov.in/content/dam/resized-web-page-banner-images-/category-/glimpses-of-odisha.jpg" alt="Chengalpattu" className="w-full h-full object-cover" />
            </div>
          </div>

           <div className="text-center">
            <p className="text-gray-900 font-semibold text-sm mb-2">Vijayawada</p>
            <div className="w-24 h-24 mx-auto rounded-full overflow-hidden shadow-xl border-4 border-white bg-white">
              <img src="https://vijayawadatourism.com/images/places-to-visit/headers/prakasam-barrage-vijayawada-entry-fee-timings-holidays-reviews-header.jpg" alt="Vijayawada" className="w-full h-full object-cover" />
            </div>
          </div>

   <div className="text-center">
            <p className="text-gray-900 font-semibold text-sm mb-2">Rajahmundry </p>
            <div className="w-24 h-24 mx-auto rounded-full overflow-hidden shadow-xl border-4 border-white bg-white">
              <img src="https://images.travelandleisureasia.com/wp-content/uploads/sites/2/2025/03/11130800/Rajamundhry-FI.jpg?tr=w-480,f-jpg,pr-true" alt="Vijayawada" className="w-full h-full object-cover" />
            </div>
          </div>

   <div className="text-center">
            <p className="text-gray-900 font-semibold text-sm mb-2">Guntur </p>
            <div className="w-24 h-24 mx-auto rounded-full overflow-hidden shadow-xl border-4 border-white bg-white">
              <img src="https://i.ytimg.com/vi/4kwDMDolab0/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLDyKpxs6ZDC4SVgZ9TYayqKwOyJnw" alt="Guntur" className="w-full h-full object-cover" />
            </div>
          </div>

        </div>

        {/* CHENNAI */}
        <div className="text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-sky-400 mb-4 tracking-wider">CHENNAI</h2>
          <div className="flex justify-center">
            <div 
              className="relative bg-gradient-to-b from-sky-400 to-sky-500 overflow-hidden shadow-2xl"
              style={{
                width: '200px',
                height: '200px',
                clipPath: 'polygon(50% 0%, 100% 0%, 100% 70%, 50% 100%, 0% 70%, 0% 0%)',
                borderRadius: '50% 50% 50% 50% / 60% 60% 40% 40%'
              }}
            >
              <img 
                src="https://www.shutterstock.com/image-photo/chennai-india-circa-march-2019-600nw-2416291361.jpg"
                alt="Chennai"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoutesUI;